import { formatDate } from '@/utils/formatDate'
import type { BoxProps} from '@chakra-ui/react'
import { Box, Text } from '@chakra-ui/react'
import type { AppInfoMessage } from 'BrokerTsLib/src/dtos'

export const AppInfoDetail = ({ appInfo: { messageHeader, messageDate, messageText }, ...rest }: { appInfo: AppInfoMessage } & Omit<BoxProps, 'id'>) => {
  return <Box {...rest}>
    <Text mb={1} fontSize='lg' fontWeight='semibold'>{messageHeader}</Text>
    {messageDate && <Text fontSize="sm" fontWeight="light">{formatDate(messageDate)}</Text>}
    <Text fontSize="md" mt={2} dangerouslySetInnerHTML={{ __html: messageText ?? '' }}></Text>
  </Box>
}